import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center">
      <div className="text-center">
        <div className="mb-6">
          <h1 className="mb-2">{t("Page not found")}</h1>
          <p className="font-medium">
            {t("The page you are looking for does not exist.")}
          </p>
        </div>

        <Link className="button" to="/">
          {t("Back to home")}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
